import { RouteRecordRaw } from 'vue-router';

import BaseLayout from '@/layouts/base-layout.vue';

/** @deprecated Unused. Remove after all tests */
const MakeTransferOperationsPage = () => import('@/modules/transfer-operations/pages/MakeTransferOperationsPage.vue');
/** @deprecated Unused. Remove after all tests */
const NostroTransferPage = () => import('@/modules/transfer-operations/pages/NostroTransferPage.vue');
/** @deprecated Unused. Remove after all tests */
const InternationalTransferPage = () => import('@/modules/transfer-operations/pages/InternationalTransferPage.vue');

const TransferTypesPage = () => import('@/_redesign/modules/Transfers/pages/TransferTypesPage.vue');
const TransferOtpConfirmationPage = () => import('@/_redesign/modules/Transfers/pages/TransferOtpConfirmation/TransferOtpConfirmationPage.vue');
/** @deprecated Unused. Remove after all tests */
const TransferOtpConfirmationPageOld = () => import('@/modules/transfer-operations/pages/TransferOtpConfirmationPageOld.vue');

const OtherBankPage = () => import('@/_redesign/modules/Transfers/pages/OtherBank/OtherBankPage.vue');
const CardNumberPage = () => import('@/_redesign/modules/Transfers/pages/CardNumber/CardNumberPage.vue');
const MassPaymentPage = () => import('@/_redesign/modules/Transfers/pages/MassPayment/MassPaymentPage.vue');
const BetweenAccountsPage = () => import('@/_redesign/modules/Transfers/pages/BetweenAccounts/BetweenAccountsPage.vue');
const AmaizUserTransferPage = () => import('@/_redesign/modules/Transfers/pages/AmaizUserTransfer/AmaizUserTransferPage.vue');

export const TRANSFER_OPERATIONS_CHILDREN: RouteRecordRaw[] = [
  {
    path: 'make-transfer-operations',
    name: 'user-make-transfer-operations',
    component: MakeTransferOperationsPage,
    props: true,
    meta: {
      layout: {
        componentName: 'RedesignLayout',
      },
    },
  },
  {
    path: 'sepa-transfer',
    name: 'user-sepa-transfer',
    component: NostroTransferPage,
    props: {
      isAccountPage: true,
      transferType: 'SEPA',
    },
    meta: {
      layout: {
        componentName: 'BasePageLayout',
      },
    },
  },
  {
    path: 'faster-payments-transfer',
    name: 'user-faster-payments-transfer',
    component: NostroTransferPage,
    props: {
      isAccountPage: true,
      transferType: 'FSP',
    },
    meta: {
      layout: {
        componentName: 'BasePageLayout',
      },
    },
  },
  {
    path: 'swift-transfer',
    name: 'user-swift-transfer',
    component: NostroTransferPage,
    props: {
      isAccountPage: true,
      transferType: 'SWIFT',
    },
    meta: {
      layout: {
        componentName: 'BasePageLayout',
      },
    },
  },
  {
    path: 'other-bank',
    name: 'user-transfer-other-bank',
    component: OtherBankPage,
    meta: {
      layout: {
        componentName: 'RedesignLayout',
        props: {
          isClosable: true,
        },
      },
    },
  },
  {
    path: 'between-accounts',
    name: 'user-transfer-between-accounts',
    component: BetweenAccountsPage,
    meta: {
      layout: {
        componentName: 'RedesignLayout',
        props: {
          isClosable: true,
        },
      },
    },
  },
  {
    path: 'to-amaiz-user',
    name: 'user-transfer-to-amaiz-user',
    component: AmaizUserTransferPage,
    meta: {
      layout: {
        componentName: 'RedesignLayout',
        props: {
          isClosable: true,
        },
      },
    },
  },
  {
    path: 'card-number',
    name: 'user-transfer-card-number',
    component: CardNumberPage,
    meta: {
      layout: {
        componentName: 'RedesignLayout',
        props: {
          isClosable: true,
        },
      },
    },
  },
  {
    path: 'international-transfer',
    name: 'user-international-transfer',
    component: InternationalTransferPage,
    props: {
      isSelfTransfer: false,
    },
    meta: {
      layout: {
        componentName: 'BasePageLayout',
      },
    },
  },
  {
    path: 'mass-payment',
    name: 'user-mass-payment',
    component: MassPaymentPage,
    meta: {
      layout: {
        componentName: 'RedesignLayout',
        props: {
          isClosable: true,
        },
      },
    },
  },
  {
    path: 'transfer-types',
    name: 'user-transfer-types',
    component: TransferTypesPage,
    meta: {
      layout: {
        componentName: 'RedesignLayout',
        props: {
          isBackVisible: true,
          backName: [
            'universal-dashboard',
            'merchant-dashboard',
            'merchant-dashboard-main',
            'user-dashboard-main',
            'merchant-dashboard-account',
            'user-dashboard-account',
            'merchant-dashboard-account-card',
            'user-dashboard-account-card',
          ],
        },
      },
    },
  },
  {
    path: 'otp-confirmation--old/:transactionId/:otpType',
    name: 'transfer-otp-confirmation--old',
    component: TransferOtpConfirmationPageOld,
    props: true,
    meta: {
      layout: {
        componentName: 'MerchantDashboardLayout',
        props: {
          isBackVisible: true,
          backParams: {},
        },
      },
    },
  },
  {
    path: 'otp-confirmation/:transactionId/:otpType',
    name: 'transfer-otp-confirmation',
    component: TransferOtpConfirmationPage,
    props: true,
    meta: {
      layout: {
        componentName: 'RedesignLayout',
        props: {
          isClosable: true,
        },
      },
    },
  },
];

export const TRANSFERS: RouteRecordRaw = {
  path: '/transfers/',
  name: 'user-transfers',
  component: BaseLayout,
  children: TRANSFER_OPERATIONS_CHILDREN,
  redirect: TRANSFER_OPERATIONS_CHILDREN[0],
};
